export const isExpiredProduct = product => {
  const currentDate = new Date().valueOf()
  const expiryDate = new Date(product.expire_at).valueOf()

  return currentDate >= expiryDate
}
